import { z } from 'zod';

export const agentTodoListSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentTodoListSettings = z.infer<typeof agentTodoListSettings>;

export const agentFileSystemSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentFileSystemSettings = z.infer<typeof agentFileSystemSettings>;

export const agentMemorySettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentMemorySettings = z.infer<typeof agentMemorySettings>;

export type AgentSettings = {
  fs: AgentFileSystemSettings;
  memory: AgentMemorySettings;
  todos: AgentTodoListSettings;
};